import { useEffect, useState } from 'react';
import { isNil } from 'lodash-es';
import { FALLBACK_HHMM, M_IN_H, MINUTE_IN_MS } from '@/constants/date.constants';

export const delimiter: string = ':';
const formatToTwoDigits = (value: number) => String(value).padStart(2, '0');
const getHHMMArr = (time?: string) => {
  if (!time || time === FALLBACK_HHMM) {
    return [];
  }

  return time.split(delimiter).map(Number);
};

export const useHHMMCounter = (showCounter: boolean, ptTime?: string): string[] => {
  const [currentHHMM, setCurrentHHMM] = useState(getHHMMArr(ptTime));
  const [hh, mm] = currentHHMM ?? [];

  useEffect(() => {
    if (ptTime) {
      setCurrentHHMM(getHHMMArr(ptTime));
    }
  }, [ptTime]);

  useEffect(() => {
    if (!showCounter || !ptTime) {
      return;
    }

    const intervalCurrentTime = setInterval(() => {
      setCurrentHHMM((prevTime: number[]) => {
        const [hours, minutes] = prevTime;
        let newHours = hours;
        let newMinutes = minutes + 1;

        if (newMinutes >= M_IN_H) {
          newMinutes = 0;
          newHours += 1;
        }

        return [newHours, newMinutes];
      });
    }, MINUTE_IN_MS);

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalCurrentTime);
    };
  }, [showCounter, ptTime]);

  if (isNil(hh) && isNil(mm)) {
    return [];
  }

  return [formatToTwoDigits(hh), formatToTwoDigits(mm)];
};
